import { FunctionalComponent, createRef, h } from 'preact';
import PurposesList from '../../components/PurposesList';

type Props = {
  categoriesTitle: string;
  featuresTitle: string;
  hideNonIabPurposes?: boolean;
  isVisible: boolean;
  purposesTitle: string;
  useInlineToggle?: boolean;
  useFromStackOnly?: boolean;
};

const TCFFirstLayerContent: FunctionalComponent<Props> = ({
  categoriesTitle,
  featuresTitle,
  hideNonIabPurposes = false,
  isVisible,
  purposesTitle,
  useInlineToggle = false,
  useFromStackOnly = false,
}) => {
  const ref = createRef();

  return (
    <PurposesList
      ref={ref}
      categoriesTitle={categoriesTitle}
      featuresTitle={featuresTitle}
      hideNonIabPurposes={hideNonIabPurposes}
      isVisible={isVisible} // should be always TRUE for TCF First Layer
      purposesTitle={purposesTitle}
      useInlineToggle={useInlineToggle}
      useFromStackOnly={useFromStackOnly}
    />
  );
};

export default TCFFirstLayerContent;
